import "@/App.css";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Philosophy } from "@/components/site/Philosophy";
import { ScreenQuiz } from "@/components/site/ScreenQuiz";
import { BigIdea } from "@/components/site/BigIdea";
import { Playground } from "@/components/site/Playground";
import { Marquee } from "@/components/site/Marquee";
import { Nostalgia } from "@/components/site/Nostalgia";
import { Metrics } from "@/components/site/Metrics";
import { Footer } from "@/components/site/Footer";
import { CustomCursor } from "@/components/site/CustomCursor";
import { ScrollProgress } from "@/components/site/ScrollProgress";
import { ConfettiLayer } from "@/components/site/ConfettiLayer";
import { PasswordGate } from "@/components/site/PasswordGate";

function App() {
  return (
    <PasswordGate>
      <div className="App min-h-screen bg-paper font-body text-ink">
        <ScrollProgress />
        <CustomCursor />
        <ConfettiLayer />
        <Nav />
        <main>
          <Hero />
          <Philosophy />
          <ScreenQuiz />
          <BigIdea />
          <Marquee />
          <Nostalgia />
          <Metrics />
          <Playground />
        </main>
        <Footer />
      </div>
    </PasswordGate>
  );
}

export default App;
